import { useState } from "react";
import MaterialTable from "@material-table/core";
import useFilterState from "../../../hooks/useFilterState";
import { releaseOrder, updatePoReady } from "../../api";
import { Button } from "@deere/fuel-react";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../../load-build/utility/constants";
import _ from "lodash";

const OrderManagementMaterialTable = (props) => {
  const orderTable = "Load Schedule";
  const {
    tableName,
    tableRef,
    columns,
    tableData,
    pageSize,
    getTableData,
    setPageNumber,
  } = props;

  const onPageChange = (e) => {
    setPageNumber(e);
  };
  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  const [selectedRowIds, setSelectedRowIds] = useState(new Set());

  return (
    <ThemeProvider theme={theme}>
      <MaterialTable
        title={tableName}
        onChangePage={(e) => onPageChange(e)}
        localization={{
          body: {
            emptyDataSourceMessage: (
              <h6 className=" left-[45%] absolute top-[40%] text-center">
                No records to display
              </h6>
            ),
          },
          pagination: {
            labelRowsPerPage: "Orders Per Page",
            labelRowsSelect: "Orders",
          },
        }}
        tableRef={tableRef}
        options={{
          rowStyle: {
            fontSize: 10,
          },
          sorting: false,
          selection: true,
          filtering: true,
          search: false,
          showTitle: false,
          draggable: false,
          pageSize: 100,
          maxBodyHeight: 600,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "400",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          tableContainerStyle: {
            maxHeight: 600,
            overflow: "auto",
          },
          pageSizeOptions: [100, 500, 1000],
          actionsCellStyle: {
            textAlign: "center",
            width: 120,
            padding: "4px",
          },
          actionsHeaderStyle: {
            textAlign: "center",
            width: 120,
          },
        }}
        columns={columnsWithFilter.map((col, index) => {
          if (
            col.tableData?.filterValue == "" ||
            col.tableData?.filterValue == null ||
            col.tableData?.filterValue == undefined
          ) {
            let colWithoutDefaultFilter = _.omit(
              col,
              "defaultFilter",
              "tableData.filterValue"
            );
            return colWithoutDefaultFilter;
          } else {
            return {
              ...col,
              defaultFilter: col.tableData?.filterValue,
            };
          }
        })}
        onSelectionChange={(selectedRows) => {
          const newSelectedIds = new Set(
            selectedRows.map((row) => row.orderPathId)
          );
          setSelectedRowIds(newSelectedIds);
        }}
        data={tableData.map((row) => ({
          ...row,
          tableData: {
            ...(row.tableData || {}),
            checked: selectedRowIds.has(row.orderPathId),
          },
        }))}
        onFilterChange={(filters) => {
          // Create a map of current filters for quick lookup
          const filterMap = new Map();
          filters.forEach((filter) => {
            filterMap.set(filter.column.tableData.id, filter.value);
          });

          // Iterate over all columns to ensure each one is checked if the value is present in the filter map
          columnsWithFilter.forEach((col, columnId) => {
            const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

            // Update the filter state for each column
            handleFilterChange(columnId, newValue);
          });
        }}
        actions={[
          {
            tooltip: "Mark All Selected Orders Forwader ready",
            icon: () => (
              <Button variant="primary" size="small" className="m-2">
                <span className="text-[12px]">Forwarder Ready</span>
              </Button>
            ),
            onClick: (evt, data) => {
              const orderPathId = [];
              data.map((a) => orderPathId.push(a.orderPathId));
              releaseOrder(orderPathId, getTableData);
            },
          },
          {
            tooltip: "Mark All Selected Orders PO ready",
            icon: () => (
              <Button variant="primary" size="small" className="m-2">
                <span className="text-[12px]">PO Ready</span>
              </Button>
            ),
            onClick: (evt, data) => {
              const orderPathId = [];
              data.map((a) => orderPathId.push(a.orderPathId));
              updatePoReady(orderPathId, getTableData);
            },
          },
        ]}
      />
    </ThemeProvider>
  );
};
export default OrderManagementMaterialTable;
